/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Eye1(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Eye1.glb')
  return (
    <group {...props} dispose={null}>
      <group position={[0, 303.61, 113.29]} rotation={[Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Eye1-White'].geometry}
          material={materials.White}
        />
        <mesh castShadow receiveShadow geometry={nodes['Eye1-Black'].geometry}>
          <meshPhysicalMaterial color={colorArr[1]} reflectivity={1} />
        </mesh>
      </group>
    </group>
  )
}

useGLTF.preload('/models/Eye1.glb')
